import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {avoid} from 'shared/utils/avoid';
import {compose} from 'shared/utils/compose';

import {isEmpty} from 'core/History';
import {useHistoryStore} from 'store/History';
import {useDispatch} from 'ui/store';
import {
  useUIStore,
  toggleHistory as toggleHistoryAction,
  closeSettings as closeSettingsAction,
} from 'store/UI';

import {useAnalytics} from 'ui/adapters/Analytics';
import {Button} from 'components/Button';

export const HistoryButton = (): ReactElement => {
  const history = useHistoryStore();
  const ui = useUIStore();
  const {historyVisible, settingsVisible} = ui;

  const toggleHistory = useDispatch(toggleHistoryAction);
  const closeSettings = useDispatch(closeSettingsAction);
  const closeOpenSettings = settingsVisible ? closeSettings : avoid;

  const registerEvent = useAnalytics(EventKind.OpenHistory);
  const registerOpening = historyVisible ? avoid : registerEvent;

  if (isEmpty(history)) return <span />;

  return (
    <Button
      fill={historyVisible}
      onPress={compose(toggleHistory, closeOpenSettings, registerOpening)}
      data-test='history-btn'
    >
      История
    </Button>
  );
};
